import type {
  ScrollToDateOptions,
  VirtualReservationListHandle,
} from "@/pages/ReservationPage/components/VirtualReservationList/VirtualReservationList";
import type { PropsWithChildren } from "react";
import { useCallback, useMemo, useRef, useState } from "react";
import { ReservationUIContext } from "./ReservationUIContext";

export function ReservationUIProvider({ children }: PropsWithChildren) {
  const listRef = useRef<VirtualReservationListHandle | null>(null);
  const [calendarMonth, setCalendarMonth] = useState(() => new Date());
  const [isMobileCalendarOpen, setMobileCalendarOpen] = useState(false);

  const scrollToDate = useCallback(
    (date: string, options?: ScrollToDateOptions) => {
      listRef.current?.scrollToDate(date, options);
    },
    [],
  );

  const openMobileCalendar = useCallback(() => {
    setMobileCalendarOpen(true);
  }, []);

  const closeMobileCalendar = useCallback(() => {
    setMobileCalendarOpen(false);
  }, []);

  const value = useMemo(
    () => ({
      listRef,
      scrollToDate,
      calendarMonth,
      setCalendarMonth,
      isMobileCalendarOpen,
      openMobileCalendar,
      closeMobileCalendar,
      setMobileCalendarOpen,
    }),
    [
      listRef,
      scrollToDate,
      calendarMonth,
      setCalendarMonth,
      isMobileCalendarOpen,
      openMobileCalendar,
      closeMobileCalendar,
      setMobileCalendarOpen,
    ],
  );

  return (
    <ReservationUIContext.Provider value={value}>
      {children}
    </ReservationUIContext.Provider>
  );
}
